import { DvFilterItem, DvToolbarActionEvent } from '@devinco/ui/grid';
import { Injectable, inject } from '@angular/core';
import { RestApiService } from '@core/services/rest-api.service';
import { SplitterWithGridHelperService } from '@features/vt-grid/services/splitter-with-grid-helper.service';
import { ToolbarActionsService } from '@features/vt-grid/services/toolbar-actions.service';
import { TranslateService } from '@ngx-translate/core';
import { Entity } from '@shared/constants/entity';
import { switchMap, take, tap } from 'rxjs';
import { EventBusService } from '../event-bus/event-bus.service';
import { EventKey } from '@shared/constants/event-bus/event-key';
import { QuickFilterId } from '@shared/constants/quick-filters/quick-filter-id';
import { QuickFilterModel } from '@shared/constants/quick-filters/quick-filter-models';

@Injectable({ providedIn: 'root' })
export class CommonQuickFiltersService {
  private translate = inject(TranslateService);
  private api = inject(RestApiService);
  private toolbarActionsService = inject(ToolbarActionsService);
  private gridEntityService = inject(SplitterWithGridHelperService);
  private eventBusService = inject(EventBusService);

  deleteEntity = (
    event: DvToolbarActionEvent,
    quickFilters: DvFilterItem[],
    activeQuickFilter: DvFilterItem | undefined,
    entity: Entity,
    customDialogTextKey = 'General.Dialog.Delete.Text'
  ): void => {
    const selectedNodeId = event.api.getSelectedNodes()[0].id as string;

    if (quickFilters.length) {
      this.toolbarActionsService
        .openRowDeleteDialog(customDialogTextKey)
        .confirm.pipe(
          switchMap(_ => {
            return this.api.upsert(entity, selectedNodeId, {
              ShowRecord: false,
            });
          }),
          switchMap(() => {
            return this.gridEntityService.refreshRowData(selectedNodeId!);
          }),
          take(1),
          tap(() => {
            if (activeQuickFilter?.id !== QuickFilterId.All) {
              const activeRecordsFilterModel = {
                ShowRecord: { filterType: 'set', values: ['false'] },
              };
              if (event.api.getFilterModel()['ShowRecord']) {
                event.api.setFilterModel(activeRecordsFilterModel);
              }
            }
            this.eventBusService.emit({ key: EventKey.SidesheetEntityDeleted });
          })
        )
        .subscribe();
    } else {
      this.toolbarActionsService.deleteSelectedRow(event);
    }
  };

  getQuickFilters(): DvFilterItem[] {
    return [
      {
        id: QuickFilterId.All,
        title: this.translate.instant('General.QuickFilter.All'),
        gridFilters: {},
        suppressDeselect: true,
      },
      {
        id: QuickFilterId.Active,
        defaultActive: true,
        title: this.translate.instant('General.QuickFilter.Active'),
        gridFilters: QuickFilterModel.Active,
        suppressDeselect: true,
      },
      {
        id: QuickFilterId.Deleted,
        title: this.translate.instant('General.QuickFilter.Deleted'),
        gridFilters: QuickFilterModel.Deleted,
        suppressDeselect: true,
      },
    ];
  }
}
